/**
 * @generated SignedSource<<9c1f21e2a7c9c1e23199eb87efc3316c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedPersonalizedSearchItems_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_user">;
  readonly " $fragmentType": "BuySharedPersonalizedSearchItems_user";
};
export type BuySharedPersonalizedSearchItems_user$key = {
  readonly " $data"?: BuySharedPersonalizedSearchItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedPersonalizedSearchItems_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b206a0d761283cbbcc3f5c8ce7aaf377";

export default node;
